import React from 'react';
import Filter from './Filter';
import { find, capitalize } from 'lodash';
import DropdownMenu from '../../common/DropdownMenu';

var tagSvg = require('!svg-inline-loader!../../../../public/img/tag.svg');
var arrowDownSvg = require('!svg-inline-loader!../../../../public/img/arrow-down.svg');
var imprintsSvg = require('!svg-inline-loader!../../../../public/img/icons/imprints.svg');
var artistsSvg = require('!svg-inline-loader!../../../../public/img/icons/artists.svg');
var productsSvg = require('!svg-inline-loader!../../../../public/img/icons/products.svg');
var tracksSvg = require('!svg-inline-loader!../../../../public/img/icons/tracks.svg');
var projectsSvg = require('!svg-inline-loader!../../../../public/img/icons/projects.svg');

const headerSettings = [
  {
    id: "entities", title: "Entity", count: "Search imprints, artists, products, tracks..."
  },
  {
    id: "text", title: "Title & Notes", count: "Search by Title or Notes"
  },
  {
    id: "occurs_at", title: "Start Date", count: "Filter by Start date range"
  },
  {
    id: "ends_at", title: "End Date", count: "Filter by end date range"
  },
  {
    id: "added_at", title: "Added At", count: "Filter by Added at range"
  }
]

const entitiesObjects = [
    { type: "imprints", icon: imprintsSvg },
    { type: "artists", icon: artistsSvg },    
    { type: "projects", icon: projectsSvg },    
    { type: "products", icon: productsSvg },
    { type: "tracks", icon: tracksSvg },
  ];

const catalogKeys = ['imprints', 'artists', 'projects', 'products', 'tracks'];

class FilterButton extends React.Component {
    
    
    constructor(props){
        super(props);
        this.state = {
            filterComponentRef: React.createRef(),
            expanded: false,
            display: []
        }
    }
    
    toggleFilter = (event, force) => {
        this.setState({
            expanded: force !== undefined ? force : !this.state.expanded
        })
    }
    
    getFilteredValue = (filtered, key) => {
        if(key == 'catalog') {
            let totalEntities = 0;
            for(let entityType of catalogKeys) {
                let entity = filtered[entityType];
                if(Array.isArray(entity))
                    totalEntities += entity.length;
            }
            return totalEntities;
        }
        else {
            let value = filtered[key]
            if(value !== undefined) {
                if(Array.isArray(value))
                    return value.length;
                else if(typeof value == 'string')
                    return value.split('_').map(capitalize).join(' ');
                else 
                    return value;
            }
        }
    }

    dropdownHeader = (filtered, entity, dropdown = true) => {
        const item = headerSettings.find(item => item.id === entity);
        const title = item.title;
        const count = item.count;

        return <span className="playlist-filter-text-item">
            <span className="playlist-filter-result-icon" dangerouslySetInnerHTML={{__html: tagSvg}}></span>
            {title} ({count == '' ? this.getFilteredValue(filtered, entity) : (this.getFilteredValue(filtered, entity) || count)})
            <a className="close-link" onClick={() => this.removeOption(entity)}>&times;</a>
            {dropdown && <span className="caret" dangerouslySetInnerHTML={{__html: arrowDownSvg}}></span>}
        </span>
    }

    mergeIcons(data, entitiesObjects) {
        return data.map(item => {
            const matchingEntity = entitiesObjects.find(entity => entity.type === item.type);
            if (matchingEntity) {
                return { ...item, icon: matchingEntity.icon };
            }
            return item;
        });
    }

    showDropdownIcon(array) {
        return array.length ? true : false
    }
    
  
    applyFilter = (filter, display) => {
        this.setState({display});
        this.toggleFilter(null, false);
        this.props.onApply(filter);
    }
    
    removeOption = (option) => {
      const { filterComponentRef } = this.state;
      filterComponentRef.current.removeOption(option);
    }
    
    render (){
        const { expanded, display, filterComponentRef } = this.state;
        const { filtered, onApply, datesBlock } = this.props;        
        return <div className="playlist-filter-holder">
            <button className={`filter-toggle-btn btn default-btn`} onClick={this.toggleFilter}><span className="fa fa-plus"></span> Add Filter</button>
            <Filter filtered={filtered} expanded={expanded} onApply={this.applyFilter} ref={filterComponentRef} />
        </div>
    }
}

export default FilterButton;